import type { SourceObject } from 'video.js/dist/types/tech/tech';

import type { PlayerSources } from '../player.config';

import { useCallback, useEffect, useMemo } from 'react';

import { useLogger } from '../../../contexts/logger-context';
import { getVideoJSSources } from '../utils/get-videojs-sources';

export function useHtmlTech(
  enabled: boolean,
  setVideoSrc: (videoSrc: SourceObject[], force: boolean) => void,
  sources?: PlayerSources,
  preferredQuality?: string
): {
  reloadSource: () => void;
} {
  const { logger: mainLogger } = useLogger();
  const logger = useMemo(() => mainLogger.getSubLogger({ name: 'HtmlTech' }), [mainLogger]);

  const reloadSource = useCallback(() => {
    if (!enabled) {
      logger.warn('Reloading source skipped, as HTML5 tech is not enabled.');
      return;
    }

    if (!sources) {
      logger.warn('No sources provided, skipping source reloading for HTML5 tech.');
      return;
    }

    const videoSrc = getVideoJSSources(sources, preferredQuality);

    setVideoSrc(videoSrc, true);
  }, [enabled, logger, sources, preferredQuality, setVideoSrc]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!sources) {
      logger.warn('No sources provided, skipping source setting for HTML5 tech.');
      return;
    }

    const videoSrc = getVideoJSSources(sources, preferredQuality);

    setVideoSrc(videoSrc, false);
  }, [enabled, logger, sources, preferredQuality, setVideoSrc]);

  return {
    reloadSource,
  };
}
